import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Accueil-buttons.css';

function NavigationButtons() {
    const location = useLocation();
    const [selectedButton, setSelectedButton] = useState(location.pathname);

    // Utilisation de useEffect pour mettre à jour le bouton sélectionné
    useEffect(() => {
        setSelectedButton(location.pathname);
    }, [location.pathname]);

    return (
        <nav className="Accueil-buttons">
            <ul>
                <li>
                    <Link
                        to="/Profile"
                        className={selectedButton === '/Profile' ? 'selected' : ''}
                        onClick={() => setSelectedButton('/Profile')}
                    >
                        <div className="icon account-icon"></div>
                        Profil
                    </Link>
                </li>
                <li>
                    <Link
                        to="/Leaderboard"
                        className={selectedButton === '/Leaderboard' ? 'selected' : ''}
                        onClick={() => setSelectedButton('/Leaderboard')}
                    >
                        <div className="icon trophy-icon"></div>
                        Classement
                    </Link>
                </li>
                <li>
                    <Link
                        to="/Accueil"
                        className={selectedButton === '/Accueil' ? 'selected accueil-button' : 'accueil-button'}
                        onClick={() => setSelectedButton('/Accueil')}
                    >
                        <div className="icon poll-icon"></div> 
                    </Link>
                </li>
                <li>
                    <Link
                        to="/Suggestion"
                        className={selectedButton === '/Suggestion' ? 'selected' : ''}
                        onClick={() => setSelectedButton('/Suggestion')}
                    >
                        <div className="icon compose-icon"></div>
                        Suggestion
                    </Link>
                </li>
                <li>
                    <Link
                        to="/Parametres"
                        className={selectedButton === '/Parametres' ? 'selected' : ''}
                        onClick={() => setSelectedButton('/Parametres')}
                    >
                        <div className="icon settings-icon"></div>
                        Paramètres
                    </Link>
                </li>
            </ul>
        </nav>
    );
}

export default NavigationButtons;
